/**
 * Sprint 6: single source of truth for localStorage keys.
 * Centralized so client.ts and AuthContext.tsx never disagree.
 */
export const TOKEN_KEY = 'wst_pilot_token';
export const USER_KEY = 'wst_pilot_user';
